/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "ரத்துசெய்"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "வாடிக்கையாளர் தரவை அணுகுவதற்கான வணிக நியாயத்தை நீங்கள் பெற்றுள்ளீர்கள்"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "பாதுகாப்பு இணக்க நோக்கங்களுக்காக உங்கள் பதிவிறக்க செயல்பாடு பதிவு செய்யப்பட்டு கண்காணிக்கப்படும்"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "நீங்கள் தொடர விரும்புகிறீர்களா?"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "பதிவிறக்குவதன் மூலம், நீங்கள் அதை ஒப்புக்கொள்கிறீர்கள்:"
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
